import React, { useEffect } from "react";
import { useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useSiteData } from "../../Contexts/SiteContext";
import { notify } from "../../Datas/Functions/toast";
import { uploadImage } from "../../Datas/Functions/upload";
import Textinput from "./FormElements/Textinput";
import ImageInput from "./FormElements/ImageInput";
import Spinner from "./SmallComponents/Spinner";

const AddBannerSection = ({ selectedBanner }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm();
  const [imgUrl, setimgUrl] = useState("");
  const [uploading, setUploading] = useState(false);

  const { setIsLoading } = useSiteData();
  const handleUploadImage = async (e) => {
    setUploading(true);
    const res = await uploadImage(e.target.files[0]);
    if (res.status === 200) setimgUrl(res.data.data.display_url);
    else notify("Error", "Something Went Wrong", "error");
    console.log(res);
    setUploading(false);
  };
  const onSubmit = (data) => {
    if (uploading) {
      notify("Warning", "Photo is not Uploaded yet", "error");
      return;
    }
    setIsLoading(true);
    data.src = imgUrl;

    console.log(data);
    setIsLoading(false);
    notify("Success", "Data Successfully Updated", "success");
    reset();
  };
  useEffect(() => {
    if (selectedBanner) {
      reset(selectedBanner);
      setimgUrl(selectedBanner.src);
    }
  }, [selectedBanner]);
  return (
    <div className="col-span-12 md:col-span-5 ">
      <div className="box rounded p-7 border dark:dark-bg-front bg-front box">
        <h1 className="text-center text-2xl font-bold">Banner Data</h1>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <Textinput
            title={"Banner Title"}
            name={"title"}
            type="text"
            errors={errors}
            className={`border rounded w-full py-2 px-4 ${
              errors.title ? "border-red-500" : "border-orange-300"
            }`}
            placeholder="Enter Banner Image Title"
            register={register("title", {
              required: "Banner Title is required",
            })}
          />
          {imgUrl === "" ? (
            <ImageInput
              title={"Banner Image"}
              name={"src"}
              errors={errors}
              className={`border rounded w-full py-2 px-4 ${
                errors?.photo ? "border-red-500" : "border-orange-300"
              }`}
              placeholder="Upload Your Photo"
              register={register("src", {
                required: "Photo is required",
              })}
              onChange={handleUploadImage}
            />
          ) : (
            <div className="w-full aspect-video">
              <img
                className="max-w-full max-h-full mx-auto"
                src={imgUrl}
                alt="Selected img"
              />
            </div>
          )}
          <Textinput
            title={"Banner Youtube/ Other Link"}
            name={"link"}
            type="text"
            errors={errors}
            className={`border rounded w-full py-2 px-4 ${
              errors.link ? "border-red-500" : "border-orange-300"
            }`}
            placeholder="Enter Backgrond Link / Youtube Link"
            register={register("link")}
          />
          <button className="site-btn px-6 py-2 w-full">
            {uploading && <Spinner />} Add Banner
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddBannerSection;
